const links = {
    github: "https://github.com/3chospirits",
    linkedin: "https://www.linkedin.com/in/edwarddan/",
    facebook: "https://www.facebook.com/ed.dan.180/",
}

export default links